<template>
  <div id="app">
    <!-- 共通のヘッダーコンポーネント -->
    <AppHeader />
    <flash-message ref="flashMsg" />

    <!-- ページコンテンツ -->
    <div class="container-area">
      <router-view />
    </div>

    <GlobalLoadingOverlay v-if="isGlobalLoading" />

    <!-- 共通のフッターコンポーネント -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "@/components/shared/AppHeader.vue"; // 共通のヘッダーコンポーネントをインポート
import FlashMessage from '@/components/shared/FlashMessage.vue';
import AppFooter from "@/components/shared/AppFooter.vue"; // 共通のフッターコンポーネントをインポート
import GlobalLoadingOverlay from "@/components/shared/GlobalLoadingOverlay.vue";
import store from "@/store"; // Vuexストアをインポート

export default {
  name: "App",
  components: {
    AppHeader,
    FlashMessage,
    AppFooter,
    GlobalLoadingOverlay,
  },
  computed: {
    isGlobalLoading() {
      return this.$store.getters.isGlobalLoading;
    }
  },
  created() {
    this.checkLoginStatus();
  },
  methods: {
    checkLoginStatus() {
      const accessToken = localStorage.getItem('accessToken');
      const client = localStorage.getItem('client');
      const uid = localStorage.getItem('uid');

      if (accessToken && client && uid) {
        store.dispatch('setLoggedIn', true);
        store.dispatch('setUserName', localStorage.getItem('userName'));
        store.dispatch('setUserRole', localStorage.getItem('userRole'));
      } else {
        store.dispatch('setLoggedIn', false);
        store.dispatch('setUserName', null);
        store.dispatch('setUserRole', null);
      }
    }
  }
};
</script>

<style>
html{
  height: 100%;
}
body{
  height: 100%;
}
#app{
  height: 100%;
  position: relative;
}
.container-area{
  position: absolute;
  top: 50px;
  width: 100%;
  height: calc(100% - 100px);
  overflow-y: scroll;
}

/* 一覧の大枠 */
.list-container {
  width: 100%;
  height: 100%;
  padding: 20px;
}

/* 一覧、詳細の大枠 */
.form-container,
.detail-container {
  width: 70%;
  padding: 20px;
  margin: 20px auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* タイトル */
.page-title{
  padding-left: 12px;
  margin-bottom: 12px;
  font-size: 32px;
  font-weight: bold;
  border-left: 8px solid #023259;
}

.search-container{
  font-size: 14px;
}
.search-container input[type="text"],
.search-container input[type="date"],
.search-container input[type="number"],
.search-container select {
  font-size: 14px;
}

/* フォームの入力ボックスデザイン */
input[type="text"],
input[type="email"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 4px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

/* ボタン配置 */
.btn-area{
  text-align: center;
}

/* マスタ一覧のテーブル */
.master-table{
  font-size: 14px;
}
.master-table thead th {
  position: sticky;
  top: 0;
  background: #003366 !important; /* 背景色を設定し、スクロール中に背景が透けるのを防ぐ */
  color: #fff !important;
  border: 1px solid #DEE2E6;
  z-index: 55;
}
.master-table thead th::before {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  width: 1px;
  height: 1px;
  background: #DEE2E6 !important; /* 背景色を設定し、スクロール中に背景が透けるのを防ぐ */
}
.master-table thead th::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: -1px;
  width: 1px;
  height: 1px;
  background: #DEE2E6 !important; /* 背景色を設定し、スクロール中に背景が透けるのを防ぐ */
}
.master-table .btn-cell{
  width: 172px;
  min-width: 172px;
  max-width: 172px;
}

/* 詳細テーブル */
.detail-container table th {
  background: #2c3e50;
  color: #fff;
}
.detail-container table th,
.detail-container table td{
  padding: 8px;
}

/* テーブル */
.table-wrapper{
  width: 100%;
  overflow-x: scroll;
  background: #BBBBBB;
  border: 1px solid #BBBBBB;
  transition: max-height 0.3s ease;
}

/* ページネーション */
.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}

.pagination-container button {
  margin: 0 10px;
}

/* おしゃれチェックボックス */
.ECM_CheckboxInput {
  padding: 12px 8px;
  display: flex;
  align-items: center;
  justify-content: start;
  cursor: pointer;
}
.ECM_CheckboxInput h4 {
  margin-bottom: 0;
  font-size: 16px;
  font-weight: normal;
}
.ECM_CheckboxInput-Input {
  margin: 0;
  width: 0;
  opacity: 0;
}
.ECM_CheckboxInput:hover{
  background: rgba(0,0,0,.05) !important;
}
.ECM_CheckboxInput:hover > .ECM_CheckboxInput-DummyInput{
  transform: scale(1.1);
}
.ECM_CheckboxInput-Input:focus + .ECM_CheckboxInput-DummyInput{
  transform: scale(1.1);
}
.ECM_CheckboxInput-Input:checked + .ECM_CheckboxInput-DummyInput {
  background: #4d7ba7;
}
.ECM_CheckboxInput-Input:checked + .ECM_CheckboxInput-DummyInput::before {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 35%;
  height: 4px;
  border-radius: 2px;
  transform: translate(-6px, 5px) rotateZ(-135deg);
  transform-origin: 2px 2px;
  background: #FFFFFF;
}
.ECM_CheckboxInput-Input:checked + .ECM_CheckboxInput-DummyInput::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  height: 4px;
  border-radius: 2px;
  transform: translate(-6px, 5px) rotateZ(-45deg);
  transform-origin: 2px 2px;
  background: #FFFFFF;
}
.ECM_CheckboxInput-DummyInput {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 32px;
  height: 32px;
  border: solid 2px transparent;
  background: rgba(0, 0, 0, .15);
  border-radius: 50%;
  transition: all .15s linear;
}
.ECM_CheckboxInput-LabelText {
  margin-left: 12px;
  display: block;
  font-size: 18px;
  font-weight: bold;
}

/* 改行反映 */
.multiline-text {
  white-space: pre;
}

/* おしゃれチェックボックス（スモールバージョン） */
.ECM_CheckboxInput-sm {
  display: flex;
  align-items: center;
  justify-content: start;
  cursor: pointer;
}
.ECM_CheckboxInput-sm h4 {
  margin-bottom: 0;
  font-size: 16px;
  font-weight: normal;
}
.ECM_CheckboxInput-Input-sm {
  margin: 0;
  width: 0;
  opacity: 0;
}
.ECM_CheckboxInput-sm:hover{
  background: rgba(0,0,0,.05) !important;
}
.ECM_CheckboxInput-sm:hover > .ECM_CheckboxInput-DummyInput-sm{
  transform: scale(1.1);
}
.ECM_CheckboxInput-Input-sm:focus + .ECM_CheckboxInput-DummyInput-sm{
  transform: scale(1.1);
}
.ECM_CheckboxInput-Input-sm:checked + .ECM_CheckboxInput-DummyInput-sm {
  background: #4d7ba7;
}
.ECM_CheckboxInput-Input-sm:checked + .ECM_CheckboxInput-DummyInput-sm::before {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 30%;
  height: 2px; /* 細く */
  border-radius: 2px;
  transform: translate(-4px, 0px) rotateZ(-135deg);
  transform-origin: 2px 2px;
  background: #FFFFFF;
}
.ECM_CheckboxInput-Input-sm:checked + .ECM_CheckboxInput-DummyInput-sm::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60%;
  height: 2px; /* 細く */
  border-radius: 2px;
  transform: translate(-2px, 1px) rotateZ(-45deg);
  transform-origin: 2px 2px;
  background: #FFFFFF;
}
.ECM_CheckboxInput-DummyInput-sm {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 20px; /* 小さくした */
  height: 20px; /* 小さくした */
  border: solid 2px transparent;
  background: rgba(0, 0, 0, .15);
  border-radius: 50%;
  transition: all .15s linear;
}
.ECM_CheckboxInput-LabelText-sm {
  margin-left: 12px;
  display: block;
  font-size: 18px;
  font-weight: bold;
}
.one-third-block{
  width: calc(100% / 3);
}
</style>
